import { call, put, takeEvery } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchSettings,
    settingsFetched,
    settingsFetchedFailed,
    updateSetting,
    settingUpdated,
    settingUpdateFailed,
    updateMessageOfDay,
    messageOfDayUpdated,
    messageOfDayUpdateFailed,
    toggleOnboarding,
    onboardingToggled,
    onboardingToggleFailed,
} from '../settings';
import { showToastAction } from '../ui';

function* fetchSettingsEffect() {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.settings,
            method: 'GET',
            queryParams: {},
        });
        yield put(
            settingsFetched({
                results: response.results,
            }),
        );
    } catch (e) {
        yield put(settingsFetchedFailed());
    }
}

function* updateSettingEffect(action) {
    const {
        payload: { data, resolve, reject },
    } = action;
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.updateSettings,
            method: 'PUT',
            body: data,
        });
        yield put(settingUpdated(response.data || response));
        yield put(
            showToastAction({
                type: 'success',
                text: 'Settings updated successfully',
            }),
        );
        yield call(resolve, response);
    } catch (e) {
        yield put(settingUpdateFailed());
        yield put(
            showToastAction({
                type: 'danger',
                text: e.message || 'Failed to update settings',
            }),
        );
        yield call(reject, e);
    }
}

function* updateMessageOfDayEffect(action) {
    const {
        payload: { data, resolve, reject },
    } = action;
    try {
        const settingsId = data.settingsId;
        const response = yield call(SendApiRequest, {
            url: apiRoutes.updateMessageOfDay(settingsId),
            method: 'PUT',
            body: {
                messageOfDay: data.messageOfDay,
                messageOfDayInFrench: data.messageOfDayInFrench,
            },
        });
        yield put(
            messageOfDayUpdated({
                messageOfDay: data.messageOfDay,
                messageOfDayInFrench: data.messageOfDayInFrench,
            }),
        );
        yield put(
            showToastAction({
                type: 'success',
                text: 'Message of the day updated successfully',
            }),
        );
        yield call(resolve, response);
    } catch (e) {
        yield put(messageOfDayUpdateFailed());
        yield put(
            showToastAction({
                type: 'danger',
                text: e.message || 'Failed to update message of the day',
            }),
        );
        yield call(reject, e);
    }
}

function* toggleOnboardingEffect(action) {
    const {
        payload: { data, resolve, reject },
    } = action;
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.enableDisableOnboarding,
            method: 'PUT',
            body: data,
        });
        yield put(onboardingToggled(response.data || response));
        yield put(
            showToastAction({
                type: 'success',
                text: 'Onboarding settings updated successfully',
            }),
        );
        yield call(resolve, response);
    } catch (e) {
        yield put(onboardingToggleFailed());
        yield put(
            showToastAction({
                type: 'danger',
                text: e.message || 'Failed to update onboarding settings',
            }),
        );
        yield call(reject, e);
    }
}

export const appSettingsSagas = [
    takeEvery(fetchSettings.type, fetchSettingsEffect),
    takeEvery(updateSetting.type, updateSettingEffect),
    takeEvery(updateMessageOfDay.type, updateMessageOfDayEffect),
    takeEvery(toggleOnboarding.type, toggleOnboardingEffect),
];
